/* Native modal behavior enhances the CSS fragment fallback. No automatic opening. */
if (!customElements.get('loow-legal-guarantee')) {
  customElements.define('loow-legal-guarantee', class extends HTMLElement {
    connectedCallback() {
      if (this.dialog || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      const panel = this.querySelector('.loow-legal-guarantee');
      if (!panel) return;
      const trigger = document.querySelector(`[data-legal-guarantee-trigger][href="#${panel.id}"]`);
      if (!trigger) return;
      const dialog = document.createElement('dialog');
      dialog.className = 'loow-legal-guarantee__dialog';
      dialog.id = `${panel.id}-dialog`;
      dialog.setAttribute('aria-labelledby', panel.getAttribute('aria-labelledby'));
      this.append(dialog);
      dialog.append(panel);
      this.dialog = dialog;
      this.trigger = trigger;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (dialog.open) return;
        dialog.showModal();
        dialog.scrollTop = 0;
        panel.querySelector('h2').focus({ preventScroll: true });
      }, options);
      panel.querySelector('[data-legal-guarantee-close]').addEventListener('click', event => {
        event.preventDefault();
        dialog.close();
      }, options);
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }), options);
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const links = [...dialog.querySelectorAll('a[href]')];
        const index = links.indexOf(document.activeElement);
        const next = event.shiftKey
          ? (index <= 0 ? links.length - 1 : index - 1)
          : (index + 1) % links.length;
        // Safari can omit links from its default Tab sequence. Keep all notice
        // actions reachable regardless of the browser's keyboard preference.
        event.preventDefault();
        links[next].focus();
      }, options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      if (!this.dialog) return;
      if (this.dialog.open) this.dialog.close();
      this.prepend(this.dialog.firstElementChild);
      this.dialog.remove();
      this.dialog = null;
      this.trigger?.removeAttribute('aria-haspopup');
      this.trigger?.removeAttribute('aria-controls');
    }
  });
}
